<template>
  <b-navbar toggleable="lg" type="dark" class="on-top">
    <b-container fluid>
      <b-navbar-brand href="#">
        <img class="logo" src="../assets/LogosBlancos.png" alt="Logo" />
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto" fill>
          <b-nav-item link-classes="text-white" href="#inicio">Inicio</b-nav-item>
          <b-nav-item link-classes="text-white" href="#servicios">Servicios</b-nav-item>
          <b-nav-item link-classes="text-white" href="#certificaciones">Certificaciones</b-nav-item>
          <b-nav-item link-classes="text-white" href="#nosotros">Nosotros</b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  name: 'Navbar'
}
</script>

<style scoped>
.logo{
  height: 7vh;
}

.navbar-toggler.collapsed{
  border:none;
}

.navbar-toggler:focus{
  outline: none;
}

.navbar-toggler.not-collapsed{
  background:rgba(256, 256,256, .1);
}

.on-top {
  position: absolute;
  width: 100%;
}
</style>
